<template>
    <div>
        <div class="placementContainer" v-for="(insertionOrder, i) in data" :key="'insertionOrder_'+i">
            <h4 @focusout="saveInsertionOrderName(insertionOrder)" contenteditable="true"
                @input="insertionOrderNameChanged($event, insertionOrder)">
                {{insertionOrder.name || headline[insertionOrder.type]+twoDigitize(i+1)}}
                <span style="margin-left: 10px" contenteditable="false" class="icon icon-edit"></span>
            </h4>
            <div class="placementContent">
                <InfoBubbleContainer title="Sites" class="item25" style="padding-left: 0;">
                    <InfoBubble :disabled="true" v-for="(site, i) in insertionOrder.sites" :key="'site_'+i" color="pink"
                                :value="site.parent_name ?site.parent_name+ ' ' +site.name:site.name"></InfoBubble>
                </InfoBubbleContainer>
                <InfoBubbleContainer title="Laufzeit" class="item25">
                    <InfoBubble :disabled="true" v-for="(date, i) in insertionOrder.dates" :key="'date_'+i" color="blue"
                                :value="formatDate(date)"></InfoBubble>
                  <div v-if="adSpecial === 'Just Video Billboard' && typeof insertionOrder.dashboard_dates !== 'undefined'&& insertionOrder.dashboard_dates.length>0">
                    <div class="dashboard-date-heading">Dashboard Laufzeiten:</div>
                    <InfoBubble :disabled="true" v-for="(date, i) in insertionOrder.dashboard_dates" :key="'date_'+i" color="blue"
                                :value="formatDate(date)"></InfoBubble>
                  </div>
                </InfoBubbleContainer>
                <div class="item50">
                    <div>
                        <InputDetail class="item50 noPadding" label="LineItem IDs"
                                     :value="stringifyArr(insertionOrder, 'line_items')"
                                     :disabled=true :style="{paddingRight: '4%'}"></InputDetail>
                        <InputDetail class="item50 noPadding" label="AdManager Creative IDs"
                                     :value="stringifyArr(insertionOrder, 'creatives')"
                                     :disabled=true></InputDetail>
                    </div>
                    <div v-if="insertionOrder.type === 'Run of Channel'" class="engagementHash"
                         :title="insertionOrder.engagement_hash">
                        {{insertionOrder.engagement_hash}}
                        <span class="icon icon-clipboard"
                              @click="copyToClipboard(insertionOrder.engagement_hash)"></span>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import InfoBubble from "../../../components/inputs/InfoBubble";
    import InfoBubbleContainer from "./InfoBubbleContainer";
    import InputDetail from "../../../components/inputs/InputDetail";
    import moment from 'moment';
    import {RepositoryFactory} from "../../../scripts/RepositoryFactory";

    const InsertionOrderRepository = RepositoryFactory.get('insertionOrders');

    export default {
        name: "PlacementSection",
        components: {InputDetail, InfoBubbleContainer, InfoBubble},
        data: function () {
            return {
                headline: {
                    "Run of Channel": "Platzierung RoC #",
                    "Run of Site": "Platzierung RoS #",
                    "Festplatzierung": "Festplatzierung #",
                }
            }
        },
        props: {
            data: Array
        },
      computed:{
          adSpecial(){
          return this.$store.state.campaign.campaign.ad_special.name;
        }
      },
        methods: {
            saveInsertionOrderName(insertionOrder) {
                if (insertionOrder.name !== '' && insertionOrder.name !== null) {
                    InsertionOrderRepository.updateInsertionOrder(insertionOrder.id, insertionOrder);
                }
            },
            insertionOrderNameChanged(event, insertionOrder) {
                insertionOrder.name = event.target.innerText;
                console.log(insertionOrder.name);
            },
            twoDigitize: function (number) {
                return ("0" + number).slice(-2);
            },
            capSite: function (sitename) {
                let nameArr = sitename.split(".");
                nameArr[0] = nameArr[0].toUpperCase();
                return nameArr.join(".");
            },
            formatDate: function (dateObj) {
                let start = moment(dateObj.start, 'YYYY-MM-DD').format('DD.MM.YY')
                let end = moment(dateObj.end, 'YYYY-MM-DD').format('DD.MM.YY')
                if (moment(dateObj.start).isSame(dateObj.end, 'day')) {
                    return start;
                } else {
                    return start + ' - ' + end;
                }
            },
            stringifyArr(insertionOrder, type) {
                let ret = '';
                for (let i = 0; i < insertionOrder[type].length; i++) {
                    ret += insertionOrder[type][i].admanager_id;
                    if ((i + 1) !== insertionOrder[type].length) ret += ', ';
                }
                return ret;
            },
            copyToClipboard: function (val) {
                let dummy = document.createElement("textarea");
                document.body.appendChild(dummy);
                dummy.value = val;
                dummy.select();
                try {
                    document.execCommand('copy');
                    this.$noty.success('Kopiert.');
                } catch (e) {
                    console.error(e);
                    this.$noty.error('Fehler bei der Speicherung in die Zwischenablage');
                }
                document.body.removeChild(dummy);
            }
        }
    }
</script>

<style lang="scss" scoped>
    h4 {
        margin-top: 0;
        margin-bottom: 1em;
    }

    .placementContainer {
        border-bottom: 1px solid #e6e7e9;
        margin: 1rem 0;
        padding-bottom: 1rem;
    }

    .placementContainer:first-child {
        margin-top: 0;
    }

    .placementContainer:last-child {
        margin-bottom: 0;
        border-bottom: none;
        padding-bottom: 0;
    }

    .placementContent {
        display: flex;
        flex-flow: wrap;
    }

    .item25 {
        min-width: calc(100% / 4);
        max-width: calc(100% / 4);
        padding: 0 10px;
    }

    .item50 {
        min-width: calc(100% / 2);
        max-width: calc(100% / 2);
        padding: 0 10px;

        > div {
            width: 100%;
        }
    }

    .noPadding {
        padding: 0;
    }

    .engagementHash {
        background: $grey;
        padding: 0.5rem 2.3rem 0.5rem 0.6rem;
        margin-top: 20px;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        .icon {
            position: absolute;
            right: 0.5rem;
            font-size: 1.3rem;
            cursor: pointer;
        }
    }

    .dashboard-date-heading{
      padding-left: 1em;
      padding-bottom: 2px;
      font-size: 0.7em;
      color: #777;
      pointer-events: none;
      -webkit-transition: 0.2s ease all;
      transition: 0.2s ease all;
    }

</style>